import React, { useState } from 'react';

const TruncatedView = ({ text, maxLength, placeholder }) => {
    const [showFullText, setShowFullText] = useState(false);

    // Function to toggle between full text and truncated text
    const toggleView = () => setShowFullText((prev) => !prev);

    // If text is empty or "null", show placeholder
    if (!text || text === "null") {
        return <span>{placeholder}</span>;
    }

    // Truncate the text
    const truncatedText =
        text.length > maxLength ? text.slice(0, maxLength) + '...' : text;

    const buttonText = text === "" ? '' : showFullText ? 'Hide' : 'View';
    const shouldShowButton = text !== "" && text.length > 20;


    return (
        <>
            {showFullText ? text : truncatedText}
            {shouldShowButton && (
                <button className="view-btn" onClick={toggleView}>
                    {buttonText}
                </button>
            )}
        </>
    );
};

export default TruncatedView;
